// Account QR component for the account page.

// Imports ----------------------------------------------------------------------------------------------------------

import ApiUtils from '@shared/utils/api';
import QRContainer from '@components/atoms/container/accountQRMainContainer';
import QRGenerator from '@components/elements/qr/qrGenerator';
import QRText from '@components/atoms/text/accountQRText';
import QRTextContainer from '@components/atoms/container/accountQRTextContainer';
import TranslationManager from '@shared/assets/locale/translationsManager';
import { useMemo } from 'react';

// Constants ----------------------------------------------------------------------------------------------------------

const LITERALS = 'PAGES.SETTINGS.ACCOUNT';

/**
 * Account QR component for the account page.
 * Displays the QR code for the account page.
 *
 * @returns {JSX.Element} Account QR component
 */
export default function AccountQR() {
  // Memoized values
  const { QRTip, QRUrl } = useMemo(() => {
    return {
      QRTip: TranslationManager.get(`${LITERALS}.MANAGE_ACCOUNT`),
      QRUrl: ApiUtils.getUrl('account_link'),
    };
  }, []);

  // Render
  return (
    <QRContainer>
      <QRGenerator scale={1.5} url={QRUrl} />
      <QRTextContainer>
        <QRText>{QRTip}</QRText>
        <QRText bold>{QRUrl}</QRText>
      </QRTextContainer>
    </QRContainer>
  );
}
